<template>
	<v-row>
		<v-col>
			<v-form
					v-model="formIsValid"
					ref="nameForm"
					class="mb-8"
					@submit.prevent="saveChanges"
			>
				<ui-box
						:form="$refs.nameForm"
						new-forms
				>
					<form-title title="Channel Name">
						Name your Channel in order to set up the web elements and add Passes to your
						website for sign-up and purchases.
					</form-title>

					<form-divider inner/>

					<v-row>
						<v-col>
							<v-text-field
									v-model="channel.name"
									class="rounded-lg required"
									clearable
									label="Channel Name"
									outlined
									persistent-hint
									:rules="rules.name"
									type="text"
							></v-text-field>
						</v-col>
					</v-row>
				</ui-box>

			</v-form>

			<save-form
					:refs="$refs"
					:is-saving="isSaving"
					:is-valid="formIsValid"
					new-forms
					save-text="Save"
					@cancel-action="cancelChanges"
					@save-action="saveChanges"
			></save-form>
		</v-col>
	</v-row>
</template>

<script>

export default {
	name: 'ChannelName',
	props: {
		channel: {
			type: Object,
			default: () => ({})
		},
		partner: {
			type: Object | null,
			default: null
		},
		returnUrl: {
			type: String,
			default: ''
		}
	},
	data() {
		return {
			exitDialog: false,
			formIsValid: false,
			isSaving: false,
			rules: {
				name: [v => !!v || 'Name is required.'],
			}
		};
	},
	methods: {
		cancelChanges() {
			window.location = this.getReturnUrl();
		},
		getReturnUrl() {
			return `/partner-portal/${this.partner.id}/channels`;
		},
		saveChanges() {
			this.$refs.nameForm.validate();
			if(!this.formIsValid) return;

			this.isSaving = true;
			const url = `/partner-portal/${this.partner.id}/channels/save-channel/${this.channel.id || ''}`;

			axios.put(url, this.channel)
					.then(({ data }) => {
						window.location = `/partner-portal/${this.partner.id}/channels/${data.channel.id}/items`;
					})
					.catch(error => {
						this.isSaving = false;
						window.EventBus.$emit('system-messages', [
							{ message: error.message, messageType: 'error' }
						]);
					});
		}
	}
};

</script>
